module.exports = __webpack_public_path__ + "img/howtomini.fcb8ad29.jpg";